import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../components/ui/dialog';
import { Button } from '../components/ui/button';
import { Clock, Rocket, MessageCircle, Shield } from 'lucide-react';

const TrialExpiredModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  const handleActivate = () => {
    onClose();
    navigate('/activar');
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-lg" data-testid="trial-expired-modal">
        <DialogHeader className="text-center">
          <div className="mx-auto w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mb-4">
            <Clock className="w-8 h-8 text-orange-600" />
          </div>
          <DialogTitle className="text-2xl font-bold text-slate-900">
            Tu periodo de prueba ha finalizado
          </DialogTitle>
          <DialogDescription className="text-slate-600 mt-2">
            Para seguir creando clientes, obras, presupuestos y facturas, 
            activa tu cuenta de MANDO.
          </DialogDescription>
        </DialogHeader>

        <div className="my-6 p-4 bg-slate-50 rounded-lg">
          <p className="text-sm text-slate-700 mb-3 font-medium">
            Tus datos están seguros. Podrás:
          </p>
          <ul className="space-y-2 text-sm text-slate-600">
            <li className="flex items-center gap-2">
              <Shield className="w-4 h-4 text-green-500" />
              Ver todo tu historial
            </li>
            <li className="flex items-center gap-2">
              <Shield className="w-4 h-4 text-green-500" />
              Consultar el dashboard
            </li>
            <li className="flex items-center gap-2">
              <Shield className="w-4 h-4 text-green-500" />
              Acceder a tus datos guardados
            </li>
          </ul>
        </div>

        <div className="space-y-3">
          <Button 
            onClick={handleActivate}
            className="w-full bg-orange-500 hover:bg-orange-600 gap-2"
            data-testid="activate-btn"
          >
            <Rocket className="w-4 h-4" />
            Activar MANDO
          </Button>
          
          <a 
            href="mailto:soporte@leapifyes.com?subject=Activación%20MANDO"
            className="flex items-center justify-center gap-2 w-full py-2 text-sm text-slate-600 hover:text-slate-900"
          >
            <MessageCircle className="w-4 h-4" />
            Hablar con un experto
          </a>
        </div>

        <p className="text-center text-xs text-slate-400 mt-4">
          No realizamos cargos automáticos. Sin compromiso.
        </p>
      </DialogContent>
    </Dialog>
  );
};

export default TrialExpiredModal;
